<template>
    <div class="dashboard">
        <div class="left">
            <h1>Hi, {{ user.name.split(' ')[0] }}!</h1>
            <h3>Welcome to mood mix</h3>

            <h3 class="your-plan">Your plan</h3>
            <div class="plan-wrapper basic" v-if="user.subscription === 'Basic'">
                <p class="title">Basic Plan</p>
            </div>

            <div class="plan-wrapper premium" v-else>
                <p class="title">Premium</p>
            </div>

            <h3 class="valid" v-if="user.subscription_end">Valid until {{ user.subscription_end }} </h3>

            <div class="subscribe" v-if="user.subscription === 'Basic'">
                <h3 class="label">Subscribe to Moodmix</h3>
                <div class="wrapper" v-for="(item, index) in list" :key="index">
                    <p class="title">{{ item.name }}</p>
                    <button @click="$router.push({ name: 'Subscription', params: {id: item.id} })">Subscribe</button>
                </div>
            </div>
        </div>

        <div class="right">
            <img :src="require('@/assets/bear.png')" alt="bear">
        </div>
    </div>
</template>

<script>
import { mapState } from 'vuex'
export default {
	data() {
		return {
			list: [],
		}
	},

	async created () {
		await this.$store.dispatch('fetchUser')
		if (this.user.subscription === 'Basic') this.list = await this.$store.dispatch('getPlanList')
	},

	computed: {
		...mapState({
			user: state => state.user
		})
	},
}
</script>

<style lang="scss" scoped>
.dashboard {
    padding-top: 40px;
    width: 1024px;
    display: flex;
    margin: auto;

    @include mobile {
        width: 380px;
    }

    @media screen and (max-width: 1024px) {
        width: 460px;
    }

    .left {
        margin-right: 100px;
        @include mobile {
            margin: auto;
        }

        h1 {
            font-family: Quicksand, sans-serif;
            color: #BAB1C9;
            font-size: 45px;
            margin-bottom: 18px;
            text-transform: capitalize;
        }

        h3 {
            color: #BAB1C9;
            font-size: 24px;
            margin-bottom: 50px;

            &.your-plan {
                margin-bottom: 15px;
            }

            &.valid {
                font-size: 18px;
                font-weight: 400;
            }
        }

        .plan-wrapper {
            width: 460px;
            height: 125px;
            border-radius: 5px;
            opacity: 1;
            padding: 45px 35px 33px;
            margin-bottom: 10px;

            @include mobile {
                width: 300px;
                padding: 26px 33px;
            }

            &.basic {
                background: transparent url('~@/assets/basic.png') 0% 0% no-repeat padding-box;
                background-size: 100%;

                .title {
                    display: inline-block;
                    padding: 5px 15px;
                    color: #ffffff;
                    background: #7FC0D3 0% 0% no-repeat padding-box;
                    font-size: 19px;
                    border-radius: 3px;
                }
                
            }

            &.premium {
                background: transparent url('~@/assets/premium.png') 0% 0% no-repeat padding-box;
                background-size: 100%;
                margin-bottom: 25px;

                .title {
                    display: inline-block;
                    padding: 5px 15px;
                    color: #ffffff;
                    background: #181E40 0% 0% no-repeat padding-box;
                    font-size: 19px;
                    border-radius: 3px;
                }
                
            }

            .title {
                color: #131215;
                font-size: 30px;
            }
        }

        .subscribe {
            margin-top: 75px;
            .label {
                color: #BAB1C9;
                font-size: 18px;
                font-weight: 400;
                margin-bottom: 18px;
            }

            .wrapper {
                width: 460px;
                height: 125px;
                background-color: #4C405F;
                border-radius: 3px;
                opacity: 1;
                padding: 25px 20px 15px;
                margin-bottom: 15px;

                @include mobile {
                    width: 300px;
                }

                .title {
                    color: #ffffff;
                    font-size: 18px;
                    margin-bottom: 26px;
                    text-transform: capitalize;
                }

                button {
                    background-color: #8158BE;
                    font-size: 16px;
                    width: 110px;
                    padding: 8px 0;
                }
            }
        }
    }

    .right {
       @media screen and (max-width: 1024px) {
           display: none;
       }
    }
}
</style>